import { eventOverviewIndex } from '~/search-domain/indexes';
import { buildEventOverviewQuery } from '~/search-domain/pipelines/event-overview/build-query';
import {
  getEventOverviewBaseFilters,
  getEventOverviewFacetAttributes,
  getEventOverviewSearchSettings,
  getEventOverviewSorting,
} from '~/search-domain/pipelines/event-overview/query-config';
import { transformEventOverviewResponse } from '~/search-domain/pipelines/event-overview/transform-response';
import { type EventOverviewESResultBody } from '~/search-domain/pipelines/event-overview/types';
import { type SearchPipelineDefinition, type SearchUiState } from '~/search-domain/types';

const resolveEventOverviewSorting = () => getEventOverviewSorting();

export const eventOverviewPipelineDefinition: SearchPipelineDefinition<SearchUiState, EventOverviewESResultBody> = {
  buildSearchRequest: buildEventOverviewQuery,
  facetAttributes: () => getEventOverviewFacetAttributes(),
  getBaseFilters: context => getEventOverviewBaseFilters(context),
  getSearchUiConfig: () => ({
    searchAttributes: getEventOverviewSearchSettings().search ?? [],
    sorting: resolveEventOverviewSorting,
  }),
  getSorting: resolveEventOverviewSorting,
  id: eventOverviewIndex,
  searchSettings: () => getEventOverviewSearchSettings(),
  transformResponse: transformEventOverviewResponse,
};
